import { useState, useEffect, useRef } from "react";
import { Row, Col, Card, Button, Modal, Checkbox, Form, Input, Select, DatePicker, Spin, Drawer, message } from "antd";
import { LoadingOutlined, SearchOutlined } from "@ant-design/icons";
import { Scrollbars } from "react-custom-scrollbars";
import data from "../../../../constants/restaurantPos.json";
import closeX from "../../../../assets/images/close-x.svg";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import "./style.css";
import { v4 as uuidv4 } from "uuid";
import db from "../../../../database";
import dayjs from "dayjs";
import { SyncData } from "./SyncData";
import TableLayout from "./TableLayout";
import { getMultilingualText } from "../../../../utils/getMultilingualText";
import { customerSearchByName } from "../../../../services";
import { getCustomer } from "../../Core/customer";
import useAuthStore from "../../../../stores/useAuthStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import useRestaurantStore from "../../../../stores/useRestaurantStore";
const { Option } = Select;

const TableManagement = (props) => {
  const [layout, setLayout] = useState("default");
  const [inputName, setInputName] = useState("default");
  const [companyInputName, setCompanyInputName] = useState("default");
  const tillData = useAuthStore((s) => s.tillData);
  const [radioFlag, setRadioFlag] = useState(false);
  const [keyboardVisible, setKeyboardVisible] = useState(true);
  const [companySearchInput, setCompanySeacrhInput] = useState("");
  const keyboardRef = useRef(null);
  const [displayCompanySearch, setDisplayCompanySearch] = useState(false);
  const companySearchInputRef = useRef();
  const [customerSearchResults, setCustomerSearchResults] = useState([]);
  const [companyName, setCompanyName] = useState("");
  const [reloadFlag, setReloadFlag] = useState(false);
  const [laywayModal, setLaywayModal] = useState(false);
  const [fbOrderLayawayData, setFbOrderLayawayData] = useState([]);
  const [tempLocatedList, setTempLocatedList] = useState([]);
  const [layawayCheck, setLayawayCheck] = useState([]);
  const posConfig = usePOSConfigStore((s) => s.posConfig);
  const [restaurantSections, setRestaurantSections] = useState([]);
  const [updateTable, setUpdateTable] = useState(false);
  const showImage = posConfig?.showImage === "Y";
  const {
    selectData,
    setSelectData,
    handleAmount,
    handleCashPayment,
    manualDiscountRestaurant,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    showOrderCompleteFlag,
    setShowOrderCompleteFlag,
    saleTypeProducts,
    setSaleTypeProducts,
    setProductsData,
    setKeyValue,
    keyValue,
    selectedTable,
    setSelectedTable,
    syncLoad,
    userPreferences,
    categorieFlag,
    setCategorieFlag,
    addDefinedProductWithAddons,
    restaurantProductCategory,
    productsData,
    pickProduct,
    increaseProductQty,
    decreaseProductQty,
    deleteProduct,
    setDisplayCustomerSearch,
    handleVoid,
    paymentVisible,
    setPaymentVisible,
    cart,
    setCart,
    deleteCart,
    handleOrder,
    showProducts,
    setShowProducts,
    tableCards,
    setTableCards,
    occupiedDataTablesData,
    setOcupiedTablesData,
    reservedTablesData,
    setReservedTablesData,
    filteredPaymentMethods,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    setNumb,
    requestPayment,
    amount,
    setAmount,
    processOrder,
    clearCartData,
    tableList,
    setTableList,
    recordState,
    setRecardState,
    mainTableData,
    setMainTableData,
    guestsModalFlag,
    setGuestsModalFlag,
    noOfPersons,
    setNumberOfPersons,
    priorityBtn,
    setPriorityBtn,
    getCustomerData,
    fireItems,
    setFireItems,
    fireMode,
    setFireMode,
    pendingFireItems,
    setPendingFireItems,
    handleCopyKOT,
    guestForm,
    kioskLogin,
    setKioskUI,
    isNewGuestCustomer,
    setIsNewGuestCustomer,
    loadReservations,
    setReservationList,
    mergeDrawerOpen,
    setMergeDrawerOpen,
    handleTable,
    inputRef,
    displayReserveTablesPopup,
    setDisplayReserveTablesPopup,
    radioValue,
    setRadioValue,
    handleReserveTable,
    reserveTableForm,
    handleNumberClick,
    handleClick,
    inputFields,
    setInputFields,
    numbers,
    handleOnChange,
    guestMobile,
    setGuestMobile,
    setReservePhone,
    reservePhone,
    addNewCustomer,
    setOederedData,
    handleDisplayOk,
    selectedProductId,
    setSelectedProductId,
    cancelKotItems,
    setCancelKotItems,
    addonSourceItem,
    setAddonSourceItem,
    showAddonsCustomizePopup,
    setShowAddonsCustomizePopUp,
    addonRepeatDisabled,
    setAddonRepeatDisabled,
    setDisplayAddOnSelection,
    displayAddOnSelection,
    selectedProduct,
    setSelectedProduct,
    setAddOnsList,
    addOnsList,
    handleAddOnModal,
    productSearchInput,
    setProductSearchInput,
    restaurantButtonLoading,
    setRestaurantButtonLoading,
    loading,
    setLoading,
  } = props;
  const isDefaultCustomer = tillData.tillAccess.csBunit.b2cCustomer.cwrCustomerId === cart?.customer?.cwrCustomerId;
  const [isNewReserveCustomer, setIsNewReserveCustomer] = useState(false);
  const [reserveSubmitting, setReserveSubmitting] = useState(false);
  const contactInputRef = useRef(null);
  const usernameData = (useAuthStore.getState().username || "").trim();
  const salesReps = tillData?.tillAccess?.csBunit?.salesRep || [];
  const matchedRep = salesReps.find((rep) => rep?.name?.toLowerCase() === usernameData.toLowerCase());

  const handleGuestCustomerSearch = async (e) => {
    let val = e.target.value.replace(/\D/g, "");
    e.target.value = val;

    setGuestMobile(val); // 🔥 Store contact number (since form doesn't have it)

    if (val.length !== 10) {
      // guestForm.setFieldsValue({ guestName: "" });
      setIsNewGuestCustomer(false);
      return;
    }

    const response = await getCustomer(guestForm, 2, val, setKioskUI, setCustomerSearchResults, kioskLogin, tillData);

    const list = response?.data?.data?.customerSearch || [];
    const match = list.find((c) => c.mobileNo?.toString() === val.toString());

    if (match) {
      guestForm.setFieldsValue({
        guestName: match.name,
      });

      setInputFields((prev) => ({ ...prev, guestName: match.name }));
      setCart((prev) => ({
        ...prev,
        customer: {
          cwrCustomerId: match.cwrCustomerId,
          name: match.name,
          mobileNo: match.mobileNo,
        },
      }));
      localStorage.setItem(
        "cartObj",
        JSON.stringify({
          ...cart,
          customer: {
            cwrCustomerId: match.cwrCustomerId,
            name: match.name,
            mobileNo: match.mobileNo,
          },
        })
      );
      setIsNewGuestCustomer(false);
      return;
    }

    // NEW customer
    // guestForm.setFieldsValue({
    //   guestName: "",
    // });

    setIsNewGuestCustomer(true);
  };

  const handleReserveCustomerSearch = async (e) => {
    let val = e.target.value.replace(/\D/g, "");
    e.target.value = val;

    if (val.length !== 10) {
      setCustomerSearchResults([]);
      reserveTableForm.setFieldsValue({
        mobile: val,
        name: "",
      });
      return;
    }

    await getCustomer(
      reserveTableForm, // 🔥 use reserveTableForm instead of guestForm
      2,
      val,
      setKioskUI,
      setCustomerSearchResults,
      kioskLogin,
      tillData
    );

    if (customerSearchResults?.length > 0) {
      const match = customerSearchResults.find((x) => x.mobileNo?.toString() === val.toString());

      if (match) {
        reserveTableForm.setFieldsValue({
          mobile: match.mobileNo,
          name: match.name,
        });
        return;
      }
    }

    // No match → treat as new customer
    reserveTableForm.setFieldsValue({
      mobile: val,
      name: "",
    });
  };

  useEffect(() => {
    const run = async () => {
      let dineInKey = useRestaurantStore.getState().dineIn !== null ? useRestaurantStore.getState().dineIn : "Y";
      const reservedData = [];
      const occupiedData = [];
      useRestaurantStore.getState().setDineIn(dineInKey);
      localStorage.setItem("customerName", undefined);
      let tempData = [];
      let data = await db.sectionTables.toArray();
      setSelectData(data);
      setRestaurantSections(data);
      await db.tableData.toArray().then((fetched) => {
        tempData.push(...fetched);
      });
      tempData.sort((a, b) => a.originalIndex - b.originalIndex);
      tempData.map((e) => {
        if (e.statusType === "OPN") {
          e.color = "#a7c957";
          e.noOfPersons = "";
          e.guestName = "";
          e.guestType = "";
          e.referredBy = "";
          e.statusType = "OPN";
          delete e.cart;
          delete e.fbOrder;
          delete e.lines;
          delete e.noOfPersons;
          delete e.waiter;
          delete e.salesRepId;
          delete e.fbOrderId;
          delete e.guestName;
          delete e.guests;
          delete e.guestType;
          delete e.referredBy;
          delete e.fbOrderStatus;
          delete e.id;
          delete e.ordered;
          // delete e.fbtableStatusId;
        } else if (e.statusType === "OCU") {
          occupiedData.push(e);
        } else {
          reservedData.push(e);
        }
      });
      setTableCards(tempData);
      setTableList(tempData);
      setMainTableData(tempData);
      setReservedTablesData(reservedData);
      setOcupiedTablesData(occupiedData);
      await db.tableData.bulkPut(tempData);
    };
    run();
    return () => {};
    // }
  }, [syncLoad, updateTable]);

  useEffect(() => {
    if (tillData.tillAccess.salesRep === "N") {
      const syncOrdersInterval = setInterval(() => {
        syncOrders();
      }, 10000);
      return () => {
        clearInterval(syncOrdersInterval);
      };
    }
    // const syncOrdersInterval = setInterval(() => {
    //   SyncData("", "upsertFbOrder");
    // }, 10000);
    // return () => {
    //   clearInterval(syncOrdersInterval);
    // };
  }, []);

  const syncOrders = async () => {
    // Fetch completed orders then filter in JS — .and() closures break in SQLite/IPC mode
    const completedOrders = await db.fbOrderData.where("fbOrderStatus").equals("CO").toArray();
    const syncedOrders = completedOrders.filter((order) => order.fbOrderSync === "Y");
    for (const order of syncedOrders) {
      await db.fbOrderData.where("id").equals(order.id).delete();
    }
  };

  const [displayMergeTablesPopup, setDisplayMergeTablesPopup] = useState(false);

  const handleSelect = (key) => {
    let tempData = [];
    if (key === "all") {
      tempData.push(...mainTableData);
      setRadioValue({ value: "all", name: "All" });
    } else {
      mainTableData.map((e) => {
        if (e.cwrFbsectionId === key) {
          tempData.push(e);
          setRadioValue({
            value: key,
            name: e.sectionName,
            noOfPersons: recordState?.noOfPersons || "",
          });
        }
      });
    }
    setTableList(tempData);
    setTableCards(tempData);
    setRadioFlag(false);
  };

  const onChangeInput = (event) => {
    const inputVal = event.target.value;
    setInputFields({
      ...inputFields,
      [inputName]: inputVal,
    });
  };

  const handleKeyboardInputs = (button) => {
    if (button === "{shift}" || button === "{default}") setLayout(layout === "default" ? "shift" : "default");
    if (button === "{caps}") setLayout("shift");
    if (button === "{small}") setLayout("default");
    if (button === "{numbers}") setLayout("numbers");
    if (button === "{number}") setLayout("number");
    if (button === "{bksp}") {
      setInputFields((prev) => {
        const updatedValue = (prev[inputName] || "").slice(0, -1);
        guestForm.setFieldsValue({ [inputName]: updatedValue });
        keyboardRef.current.setInput(updatedValue);
        return { ...prev, [inputName]: updatedValue };
      });
    }
  };

  const handleKeyboardInputs1 = (button) => {
    if (button === "{shift}" || button === "{default}") setLayout(layout === "default" ? "shift" : "default");
    if (button === "{caps}") setLayout("shift");
    if (button === "{small}") setLayout("default");
    if (button === "{numbers}") setLayout("numbers");
    if (button === "{number}") setLayout("number");
    if (button === "{bksp}") {
      setInputFields((prev) => {
        const updatedValue = (prev[inputName] || "").slice(0, -1);
        reserveTableForm.setFieldsValue({ [inputName]: updatedValue });
        keyboardRef.current.setInput(updatedValue);
        return { ...prev, [inputName]: updatedValue };
      });
    }
  };

  const onChange = (inputs) => {
    setInputFields({ ...inputs });
    guestForm.setFieldsValue(inputs);
    if (inputs.contactNumber !== undefined) {
      handleGuestCustomerSearch({
        target: { value: inputs.contactNumber },
      });
    }
  };

  const onChangeCompany = (inputs) => {
    setInputFields({ ...inputs });
    setCompanySeacrhInput(inputs.customerSearchInput);
    getCompanyData(inputs.customerSearchInput);
  };

  const handleReserveTableDetails = async (values) => {
    if (reserveSubmitting) return;
    setReserveSubmitting(true);
    try {
      let tableId = null;
      let sectionId = null;

      if (values.tableNum) {
        [tableId, sectionId] = values.tableNum.split("-");
      }

      if (isNewReserveCustomer) {
        const newCust = {
          name: values.name || "",
          mobile: reservePhone,
          email: "",
          pincode: "",
          city: "",
          street: "",
          lastName: "",
        };
        await addNewCustomer(newCust);
      }

      const item = {
        uniqueId: "RES-" + Date.now(),
        cwrFbTableId: tableId,
        cwrFbsectionId: sectionId,
        name: values.name,
        noOfPersons: Number(values.noOfPersons),
        mobile: reservePhone,
        sectionName: values.section,
        table: values.tableNum,
        specialReq: "",
        time: values.time,
      };

      await SyncData(item, "reservation");

      message.success("Table reserved successfully");

      reserveTableForm.resetFields();
      setReservePhone("");
      setDisplayReserveTablesPopup(false);

      await loadReservations();
    } finally {
      setReserveSubmitting(false);
    }
  };

  const handleCheckIn = async (reservation) => {
    const tableId = reservation.tableId;

    const payload = {
      cwrFbTableId: tableId,
      status: "RES",
      noOfPersons: reservation.guests,
      guestName: reservation.name,
      fbtableStatusId: reservation.id,
    };

    SyncData(payload, "upsertTableStatus");

    // Update local UI
    await db.tableData.update(tableId, {
      statusType: "OCU",
      color: "#e76f51",
      noOfPersons: reservation.guests,
      guestName: reservation.name,
    });

    // remove from reservation list
    setReservationList((prev) => prev.filter((r) => r.id !== reservation.id));

    message.success("Guest checked in");
  };

  const handleReserveCustomerSearchTop = async (e) => {
    let val = e.target.value.replace(/\D/g, "");
    e.target.value = val;

    setReservePhone(val); // 🔥 store phone like guest flow

    if (val.length !== 10) {
      reserveTableForm.setFieldsValue({ name: "" });
      setIsNewReserveCustomer(false);
      return;
    }

    const response = await getCustomer(reserveTableForm, 2, val, setKioskUI, setCustomerSearchResults, kioskLogin, tillData);

    const list = response?.data?.data?.customerSearch || [];

    const match = list.find((x) => x.mobileNo?.toString() === val.toString());

    if (match) {
      reserveTableForm.setFieldsValue({
        name: match.name,
      });

      // ⭐ UPDATE CART CUSTOMER
      setCart((prev) => ({
        ...prev,
        customer: {
          cwrCustomerId: match.cwrCustomerId,
          name: match.name,
          mobileNo: match.mobileNo,
        },
      }));
      localStorage.setItem(
        "cartObj",
        JSON.stringify({
          ...cart,
          customer: {
            cwrCustomerId: match.cwrCustomerId,
            name: match.name,
            mobileNo: match.mobileNo,
          },
        })
      );

      setIsNewReserveCustomer(false);
    } else {
      reserveTableForm.setFieldsValue({ name: "" });
      setIsNewReserveCustomer(true);
    }
  };

  const getCompanyData = async (value) => {
    try {
      const response = await customerSearchByName(value);
      if (response.data.data.customerSearch !== null && response.data.data.customerSearch.length > 0) {
        const result = response.data.data.customerSearch;
        setCustomerSearchResults(result);
      } else {
        console.warn("No customer found, try searching with different customer");
        setCustomerSearchResults([]);
      }
    } catch (err) {
      console.debug(err);
    }
  };

  const openCompanyData = () => {
    setDisplayCompanySearch(true);
    companySearchInputRef?.current?.focus();
  };

  const selectCompanyData = (name) => {
    guestForm.setFieldsValue({ referredBy: name });
    reserveTableForm.setFieldsValue({ referredBy: name });
    setCompanyName(name);
    setDisplayCompanySearch(false);
  };

  const handleCheckboxChange = (e, node) => {
    const isChecked = e.target.checked;
    let tabledata = useRestaurantStore.getState().locatedList;
    tabledata.forEach((item) => {
      if (item.id === node.fbTableId) {
        if (isChecked) {
          // Add the node to layawayData
          let layaway = layawayCheck ? layawayCheck : [];
          item.layawayData = [...layaway, node];
          setLayawayCheck(item.layawayData);
        } else {
          // Remove the node from layawayData
          item.layawayData = item.layawayData.filter((ele) => ele.uniqId !== node.uniqId);
          setLayawayCheck(item.layawayData);
        }
      }
    });
    setTempLocatedList(tabledata);
  };

  const cancelTableOccupation = async (recordState) => {
    try {
      await db.tableData
        .where("cwrFbTableId")
        .equals(recordState?.cwrFbTableId)
        .modify((item) => {
          item.ordered = "N";
          item.statusType = "OPN";
          item.color = "rgba(146, 144, 152, 0.5)";
          item.tabbleSync = "N";
          item.guestName = "";
          item.noOfPersons = 0;
          item.guestType = "";
          item.waiter = null;
        });

      const parkedOrder = await db.fbOrderData.where("cwrFbTableId").equals(recordState?.cwrFbTableId).first();
      if (parkedOrder) {
        await db.fbOrderData.where("fbOrderId").equals(parkedOrder.fbOrderId).delete();
      }

      const tableRecord = {
        cwrFbTableId: recordState?.cwrFbTableId,
        fbtableStatusId: recordState?.fbtableStatusId || "",
        cwrFbsectionId: recordState?.cwrFbsectionId || recordState?.fbSectionId || "",
        statusType: "OPN",
        noOfPersons: 0,
        guestName: "",
        guestType: "",
        waiter: null,
      };

      await SyncData(tableRecord, "upsertTableStatus");

      const updatedTableData = await db.tableData.toArray();
      setTableCards(updatedTableData);
      setOcupiedTablesData(updatedTableData.filter((t) => t.statusType === "OCU" || t.statusType === "ONG"));
      setReservedTablesData(updatedTableData.filter((t) => t.statusType === "RES"));
      const tempData = [];
      await db.tableData.toArray().then((fetched) => tempData.push(...fetched));
      setTableList(tempData);

      return true;
    } catch (err) {
      console.error("cancelTableOccupation error", err);
      return false;
    }
  };

  useEffect(() => {
    if (!guestsModalFlag) return;
    if (!salesReps?.length) return;

    const existingWaiterId = guestForm.getFieldValue("waiterId");

    // 🚫 Do NOT override if user already selected a waiter
    if (existingWaiterId) return;

    const defaultRep = matchedRep || salesReps[0];

    guestForm.setFieldsValue({
      waiter: defaultRep.name,
      waiterId: defaultRep.salesRepresentId,
    });
  }, [guestsModalFlag, matchedRep, salesReps]);

  useEffect(() => {
    if (guestsModalFlag) {
      setTimeout(() => {
        contactInputRef.current?.focus();
        setInputName("contactNumber");
        setLayout("num");
      }, 150);
    }
  }, [guestsModalFlag]);

  const tableLayoutProps = {
    cancelKotItems,
    setCancelKotItems,
    mergeDrawerOpen,
    setMergeDrawerOpen,
    setDisplayReserveTablesPopup,
    displayReserveTablesPopup,
    recordState,
    setRecardState,
    handleAmount,
    manualDiscountRestaurant,
    isCardPaymentFlag,
    setIsCardPaymentFlag,
    processOrder,
    showOrderCompleteFlag,
    setShowOrderCompleteFlag,
    amount,
    setAmount,
    requestPayment,
    paymentVisible,
    saleTypeProducts,
    setSaleTypeProducts,
    setProductsData,
    tableCards,
    handleTable,
    setFbOrderLayawayData,
    setLaywayModal,
    mainTableData,
    setTableCards,
    setMainTableData,
    restaurantSections,
    handleReserveTable,
    occupiedDataTablesData,
    reservedTablesData,
    setReservedTablesData,
    userPreferences,
    setKeyboardVisible,
    setGuestsModalFlag,
    setInputFields,
    guestForm,
    setOcupiedTablesData,
    showProducts,
    setShowProducts,
    categorieFlag,
    setCategorieFlag,
    addDefinedProductWithAddons,
    restaurantProductCategory,
    productsData,
    pickProduct,
    increaseProductQty,
    decreaseProductQty,
    deleteProduct,
    setDisplayCustomerSearch,
    handleVoid,
    setPaymentVisible,
    cart,
    setCart,
    deleteCart,
    setKeyValue,
    handleOrder,
    tableCards,
    setTableCards,
    reservedTablesData,
    setReservedTablesData,
    filteredPaymentMethods,
    selectedPaymentMethod,
    setSelectedPaymentMethod,
    setNumb,
    handleCashPayment,
    ...props,
  };

  return (
    <Spin indicator={<LoadingOutlined style={{ fontSize: 40, marginTop: "18vh", color: "#fff" }} spin />} spinning={false}>
      {keyValue === "0" && (
        <div style={{ height: "100%", width: "100%", backgroundColor: "#F3F4F9" }}>
          <div style={{ display: "flex" }}>
            <div style={{ width: "100%" }}>
              {keyValue === "0" && (
                <TableLayout
                  {...tableLayoutProps}
                  tableCards={tableCards}
                  setTableCards={setTableCards}
                  reservedTablesData={reservedTablesData}
                  setReservedTablesData={setReservedTablesData}
                  setProductsData={setProductsData}
                  paymentVisible={paymentVisible}
                  filteredPaymentMethods={filteredPaymentMethods}
                  selectedPaymentMethod={selectedPaymentMethod}
                  setSelectedPaymentMethod={setSelectedPaymentMethod}
                  requestPayment={requestPayment}
                  mainTableData={mainTableData}
                  setMainTableData={setMainTableData}
                  setFireItems={setFireItems}
                  fireItems={fireItems}
                  fireMode={fireMode}
                  setFireMode={setFireMode}
                  pendingFireItems={pendingFireItems}
                  setPendingFireItems={setPendingFireItems}
                  handleCopyKOT={handleCopyKOT}
                  selectData={selectData}
                  setSelectData={setSelectData}
                  tableList={tableList}
                  setTableList={setTableList}
                  setOederedData={setOederedData}
                  handleDisplayOk={handleDisplayOk}
                  selectedProductId={selectedProductId}
                  setSelectedProductId={setSelectedProductId}
                  saleTypeProducts={saleTypeProducts}
                  setsaleTypeProducts={setSaleTypeProducts}
                    addonSourceItem={addonSourceItem}
                    setAddonSourceItem={setAddonSourceItem}
                    showAddonsCustomizePopup={showAddonsCustomizePopup}
                    setShowAddonsCustomizePopUp={setShowAddonsCustomizePopUp}
                    addonRepeatDisabled={addonRepeatDisabled}
                    setAddonRepeatDisabled={setAddonRepeatDisabled}
                    setDisplayAddOnSelection={setDisplayAddOnSelection}
                    displayAddOnSelection={displayAddOnSelection}
                    selectedProduct={selectedProduct}
                    setSelectedProduct={setSelectedProduct}
                    setAddOnsList={setAddOnsList}
                    addOnsList={addOnsList}
                    handleAddOnModal={handleAddOnModal}
                    productSearchInput={productSearchInput}
                    setProductSearchInput={setProductSearchInput}
                    restaurantButtonLoading={restaurantButtonLoading}
                    setRestaurantButtonLoading={setRestaurantButtonLoading}
                    loading={loading}
                    setLoading={setLoading}
                />
              )}
            </div>
          </div>
        </div>
      )}

      {/* MERGE TABLES POPUP STARTS */}
      <Modal open={displayMergeTablesPopup} closable={false} footer={null} styles={{ body: { padding: 20 } }} width="30%" style={{ top: 200 }}>
        <div>
          <Row style={{ paddingTop: 10 }}>
            <Col span={24}>
              <p style={data.restaurantPos.tableManagement.mergeTables.modalTitle}>Are you sure want to Merge the Tables?</p>
            </Col>
          </Row>
          <Row style={data.restaurantPos.tableManagement.mergeTables.yesCancelBtns}>
            <Button
              size="medium"
              className="customerDetailsSubmitBtnBtn"
              style={data.restaurantPos.tableManagement.mergeTables.mergeTablesSubmitBtn}
              htmlType="submit"
              onClick={() => setDisplayMergeTablesPopup(false)}
            >
              Yes
            </Button>
            <Button
              size="medium"
              className="customerDetailsCancelBtn"
              style={data.restaurantPos.tableManagement.mergeTables.mergeTablesCancelBtn}
              onClick={() => setDisplayMergeTablesPopup(false)}
            >
              No
            </Button>
          </Row>
        </div>
      </Modal>

      <Drawer
        open={guestsModalFlag}
        placement="right"
        closable={false}
        width="80%"
        className="custom-drawer"
        styles={{ mask: { backgroundColor: "rgba(0,0,0,0.3)" } }}
        styles={{ body: { backgroundColor: "#fff" } }}
      >
        <Row style={{ paddingLeft: "1.2vw", fontSize: "1vw" }} className="test">
          <Col
            span={16}
            style={{
              display: "flex",
              alignItems: "center",
              paddingTop: "1vh",
              paddingBottom: "1vh",
            }}
          >
            <p style={{ fontSize: "1.5em", color: "#0f0718", fontWeight: "500", marginTop: "0.5vh" }}>{getMultilingualText("Guest Registration")}</p>
          </Col>
        </Row>
        <Form form={guestForm} name="guestForm" onFinish={getCustomerData}>
          <Row>
            <Col span={12} style={{ padding: "0 1vw", fontSize: "1vw" }}>
              <Form.Item
                name="contactNumber"
                rules={[
                  { required: true, message: "Please enter contact number" },
                  { len: 10, message: "Contact number must be 10 digits" },
                ]}
              >
                <Input
                  placeholder={getMultilingualText("Contact Number")}
                  ref={contactInputRef}
                  className="restaurantInput"
                  style={{
                    width: "100%",
                    height: "32px",
                    fontSize: "0.9em",
                    borderRadius: "8px",
                  }}
                  onFocus={() => {
                    setInputName("contactNumber");
                    setLayout("num");
                  }}
                  onChange={(e) => {
                    guestForm.setFieldsValue({ contactNumber: e.target.value }); // sync form
                    handleGuestCustomerSearch(e); // your logic
                  }}
                  maxLength={10}
                  type="number"
                  onKeyPress={(e) => {
                    if (["e", "E", "+", "-", ".", ","].includes(e.key)) e.preventDefault();
                  }}
                />
              </Form.Item>
              {posConfig?.showGuestTypeTabs === "Y" ? (
                <Row gutter={[16, 16]} style={{ marginBottom: "15px" }}>
                  <Col span={11}>
                    <Button
                      className="section-btn"
                      onClick={() => setPriorityBtn(false)}
                      style={{
                        backgroundColor: priorityBtn ? "#fff" : "#2F3856",
                        color: priorityBtn ? "#2F3856" : "#fff",
                        boxShadow: "none",
                        border: "1px solid rgba(146, 144, 152, 0.5)",
                        borderRadius: "5px",
                        fontSize: "1.2em",
                        fontWeight: "500",
                      }}
                    >
                      {getMultilingualText("Family")}
                    </Button>
                  </Col>
                  <Col span={2} />
                  <Col span={11}>
                    <Button
                      className="section-btn"
                      onClick={() => setPriorityBtn(true)}
                      style={{
                        backgroundColor: !priorityBtn ? "#fff" : "#2F3856",
                        color: !priorityBtn ? "#2F3856" : "#fff",
                        boxShadow: "none",
                        border: "1px solid rgba(146, 144, 152, 0.5)",
                        borderRadius: "5px",
                        fontSize: "1.2em",
                        fontWeight: "500",
                      }}
                    >
                      {getMultilingualText("Others")}
                    </Button>
                  </Col>
                </Row>
              ) : null}
              <div
                style={{
                  maxHeight: "60vh",
                  overflowY: "auto",
                  overflowX: "hidden",
                  paddingRight: "10px", // Give space for scrollbar
                  paddingLeft: "8px", // Prevent left-side clipping
                  //marginLeft: "-4px",       // Compensate for the padding (optional)
                  // This is the key for modern browsers:
                  overflow: "overlay", // Allows pseudo-elements to render outside bounds
                }}
              >
                <Row gutter={[0, 16]}>
                  {posConfig?.requireWaiterAllocation === "Y" ? (
                    <Col span={24}>
                      <label style={data.restaurantPos.tableManagement.reserveTableModal.tableDetailsField}>
                        <span style={{ color: "red", marginRight: "5px" }}>*</span>
                        {getMultilingualText("Waiter")}
                      </label>

                      <Form.Item name="waiterId" style={{ display: "none" }}>
                        <Input type="hidden" />
                      </Form.Item>
                      {/* Text Input (focusable, shows keyboard) */}
                      {/* <Form.Item
                        name="waiter"
                        rules={[
                          {
                            required: true,
                            message: "Please enter or select waiter",
                          },
                        ]}
                        style={data.restaurantPos.tableManagement.reserveTableModal.formItem}
                      ></Form.Item> */}

                      {/* Card List for Quick Selection */}
                      {/* <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          flexWrap: "wrap",
                          marginTop: "8px",
                        }}
                      >
                        {tillData?.tillAccess?.csBunit?.salesRep?.map((item, index) => {
                          const selectedWaiterId = guestForm?.getFieldValue("waiterId");
                          const isSelected = selectedWaiterId === item.salesRepresentId; // ✔ FIXED

                          return (
                            <div
                              key={item.salesRepresentId}
                              onClick={() => {
                                guestForm.setFieldsValue({
                                  waiter: item.name,
                                  waiterId: item.salesRepresentId, // ✔ store unique ID
                                });
                              }}
                              style={{
                                cursor: "pointer",
                                padding: "10px 18px",
                                borderRadius: "8px",
                                border: isSelected ? "2px solid #2F3856" : "1px solid #ccc",
                                backgroundColor: posConfig?.showImage === "N" ? ["#FFE8D6", "#E8EAF6", "#E3F2FD", "#FCE4EC"][index % 4] : "#fff",
                                opacity: isSelected ? 1 : 0.9,
                                transition: "all 0.2s",
                              }}
                            >
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "1em",
                                  fontWeight: isSelected ? "600" : "500",
                                  color: "#0F0718",
                                }}
                              >
                                {item.name}
                              </p>
                            </div>
                          );
                        })}
                      </div> */}
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          flexWrap: "wrap",
                          marginTop: "8px",
                        }}
                      >
                        {salesReps.map((item, index) => {
                          const selectedWaiterId = guestForm?.getFieldValue("waiterId");
                          const isSelected = selectedWaiterId === item.salesRepresentId;

                          // 🚫 if matchedRep exists, only that waiter is enabled
                          const isDisabled = matchedRep && item.salesRepresentId !== matchedRep.salesRepresentId;

                          return (
                            <div
                              key={item.salesRepresentId}
                              onClick={() => {
                                if (isDisabled) return; // don't allow click
                                guestForm.setFieldsValue({
                                  waiter: item.name,
                                  waiterId: item.salesRepresentId,
                                });
                              }}
                              style={{
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                padding: "10px 18px",
                                borderRadius: "8px",
                                border: isSelected ? "2px solid #2F3856" : "1px solid #ccc",
                                backgroundColor: posConfig?.showImage === "N" ? ["#FFE8D6", "#E8EAF6", "#E3F2FD", "#FCE4EC"][index % 4] : "#fff",
                                opacity: isDisabled ? 0.4 : isSelected ? 1 : 0.9,
                                pointerEvents: isDisabled ? "none" : "auto", // extra safety
                                transition: "all 0.2s",
                              }}
                            >
                              <p
                                style={{
                                  margin: 0,
                                  fontSize: "1em",
                                  fontWeight: isSelected ? "600" : "500",
                                  color: "#0F0718",
                                }}
                              >
                                {item.name}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </Col>
                  ) : null}

                  {posConfig?.requireGuestName === "Y" ? (
                    <Col span={24}>
                      <label style={data.restaurantPos.tableManagement.reserveTableModal.tableDetailsField}>
                        {posConfig?.requireGuestInformation === "Y" && <span style={{ color: "red", marginLeft: "-9px", paddingRight: "3px" }}>*</span>}
                        {getMultilingualText("Guest Name")}
                      </label>
                      <Form.Item
                        name="guestName"
                        rules={[{ required: posConfig?.requireGuestName === "Y", message: "Please enter guest name" }]}
                        style={data.restaurantPos.tableManagement.reserveTableModal.formItem}
                      >
                        <Input
                          ref={inputRef}
                          className="restaurantInput"
                          placeholder="Guest Name"
                          onFocus={() => {
                            setInputName("guestName");
                            setLayout("default");
                          }}
                          onKeyDown={(e) => {
                            const allowed = /^[A-Za-z\s]$/;
                            if (!allowed.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                  ) : null}

                  {posConfig?.requireNoOfGuests === "Y" ? (
                    <Col span={24}>
                      <label style={data.restaurantPos.tableManagement.reserveTableModal.tableDetailsField}>
                        <span
                          style={{
                            color: "red",
                            marginLeft: "-9px",
                            paddingRight: "3px",
                          }}
                        >
                          *
                        </span>
                        {getMultilingualText("No Of Guests")}
                      </label>
                      <Form.Item
                        name="noOfGuests"
                        rules={[
                          {
                            required: posConfig?.requireNoOfGuests === "Y" ? true : false,
                            message: "Please enter No Of Guests",
                          },
                        ]}
                        style={data.restaurantPos.tableManagement.reserveTableModal.formItem}
                      >
                        <Input
                          placeholder="No Of Guests"
                          className="restaurantInput"
                          ref={inputRef}
                          type="number"
                          onFocus={() => {
                            setInputName("noOfGuests");
                            setLayout("num");
                          }}
                          value={inputFields.noOfGuests || ""}
                          onKeyPress={(e) => {
                            if (["e", "E", "+", "-", "."].includes(e.key)) {
                              e.preventDefault();
                            }
                          }}
                          onChange={onChangeInput}
                          style={data.restaurantPos.tableManagement.reserveTableModal.tableDetailsInput}
                        />
                      </Form.Item>
                    </Col>
                  ) : null}

                  {posConfig?.showSelectCompanyOption === "Y" ? (
                    <Col span={24}>
                      {/* <label style={data.restaurantPos.tableManagement.reserveTableModal.tableDetailsField}>Referred By</label> */}
                      <Form.Item name="referredBy" style={data.restaurantPos.tableManagement.reserveTableModal.formItem}>
                        <Row gutter={[16, 16]}>
                          <Col span={11}>
                            <a onClick={openCompanyData}>{getMultilingualText("Select Company")}</a>
                          </Col>
                          <Col span={2} />
                          <Col span={11} style={{ textAlign: "center", alignSelf: "center" }}>
                            <span>{companyName}</span>
                          </Col>
                        </Row>
                      </Form.Item>
                    </Col>
                  ) : null}
                </Row>
              </div>
            </Col>
            <Col span={12} style={{ marginTop: "1%", padding: "0 1vw" }}>
              {keyboardVisible && posConfig?.enableKeyboardOnGuestForm === "Y" && (
                <Keyboard
                  buttonTheme={[
                    {
                      class: "hg-bksp",
                      buttons: "{bksp} {backspace}",
                    },
                    {
                      class: "hg-space",
                      buttons: "{space}",
                    },
                  ]}
                  keyboardRef={(r) => (keyboardRef.current = r)}
                  inputName={inputName}
                  onChangeAll={onChange}
                  onKeyPress={handleKeyboardInputs}
                  layoutName={layout}
                  theme={"hg-theme-default signUp"}
                  display={{
                    "{abc}": "ABC",
                    "{smileys}": "\uD83D\uDE03",
                    "{numbers}": "123",
                    "{number}": "123",
                    "{shift}": "⇧",
                    "{tab}": "tab",
                    "{lock}": "lock",
                    "{enter}": "enter",
                    "{space}": "Space",
                    "{caps}": "ABC",
                    "{small}": "abc",
                  }}
                  layout={{
                    shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {bksp}", "{number} {space}"],
                    numbers: ["1 2 3", "4 5 6", "7 8 9", "{caps} 0 {bksp}"],
                    number: ["1 2 3", "4 5 6", "7 8 9", "{small} 0 {bksp}"],
                    default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {bksp}", "{numbers} {space}"],
                    num: ["1 2 3", "4 5 6", "7 8 9", " 0 {bksp}"],
                  }}
                />
              )}
            </Col>
            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
                padding: "1.5vh 1.2vw",
                background: "#ffffff",
                borderTop: "1px solid #e5e5e5",
                display: "flex",
                justifyContent: "space-between",
                gap: "12px",
                zIndex: 999,
                marginBottom: "3vh",
              }}
            >
              <Button
                size="large"
                className="modal-btn"
                style={{
                  width: "50%",
                  background: "#2F3856",
                  color: "#fff",
                  borderRadius: "8px",
                  fontSize: "1.1em",
                }}
                htmlType="submit"
              >
                {getMultilingualText("Okay")}
              </Button>

              <Button
                size="large"
                className="modal-btn"
                style={{
                  width: "50%",
                  background: "#fff",
                  border: "1px solid #ccc",
                  borderRadius: "8px",
                  fontSize: "1.1em",
                }}
                onClick={async () => {
                  await cancelTableOccupation(recordState);
                  setInputFields("");
                  setKeyboardVisible(false);
                  guestForm.resetFields();
                  setGuestMobile("");
                  setTimeout(() => {
                    setKeyboardVisible(true);
                    setGuestsModalFlag(false);
                  }, 0);
                }}
              >
                {getMultilingualText("Cancel")}
              </Button>
            </div>
          </Row>
        </Form>
      </Drawer>
      <Modal
        open={radioFlag}
        title={"Section Table"}
        closable={true}
        footer={null}
        onCancel={() => {
          setRadioFlag(false);
        }}
        styles={{ body: { padding: "15px" } }}
        width="55%"
      >
        <Row gutter={[16, 16]}>
          {selectData.map((item) => (
            <Col span={6}>
              <Button className="section-btn" onClick={() => handleSelect(item.value)}>
                {item.name}
              </Button>
            </Col>
          ))}
        </Row>
      </Modal>
      <Modal
        title={
          <div>
            <Row>
              <Col span={24}>
                <p style={data.restaurantPos.tableManagement.reserveTableModal.modalTitle}>Search Company</p>
              </Col>
            </Row>
          </div>
        }
        open={displayCompanySearch}
        closable={true}
        footer={null}
        width="70%"
        onCancel={() => setDisplayCompanySearch(false)}
        keyboard={false}
        styles={{ body: { padding: 15 } }}
      >
        <Row>
          <Col span={9}>
            <Input
              ref={companySearchInputRef}
              placeholder="Search"
              size="large"
              readOnly
              className="customerSearchInput"
              suffix={<SearchOutlined onClick={getCompanyData} />}
              onFocus={() => {
                setCompanyInputName("customerSearchInput");
                setLayout("default");
              }}
              value={companySearchInput}
              onPressEnter={getCompanyData}
              onChange={(e) => {
                onChangeCompany;
              }}
            />
            <Row style={{ paddingTop: 10 }}>
              <Col span={24}>
                {
                  <div style={{ textAlign: "left" }}>
                    <Card
                      bordered
                      styles={{ body: { padding: 10 } }}
                      style={{
                        maxHeight: "60vh",
                        minHeight: "55vh",
                        boxShadow: "0px 3px 6px #00000029",
                        borderRadius: "5px",
                      }}
                    >
                      <Scrollbars autoHide className="customerCardScroll">
                        {customerSearchResults.map((customerSearchResult, index) => (
                          <Card
                            tabIndex={0}
                            // onKeyPress={(e) => (e.charCode === 13 ? selectCustomer(index) : null)}
                            onClick={() => {
                              selectCompanyData(customerSearchResult.name);
                              localStorage.setItem("customerName", JSON.stringify(customerSearchResult));
                            }}
                            key={`${index}`}
                            styles={{ body: { padding: 10 } }}
                            style={{
                              background: "#0C173A0d",
                              marginBottom: "10px",
                            }}
                          >
                            <Row>
                              <Col span={24}>
                                <p>{customerSearchResult.name}</p>
                              </Col>
                            </Row>
                          </Card>
                        ))}
                      </Scrollbars>
                    </Card>
                  </div>
                }
              </Col>
            </Row>
          </Col>
          <Col span={1} />
          <Col
            span={14}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {keyboardVisible && (
              <Keyboard
                buttonTheme={[
                  {
                    class: "hg-bksp",
                    buttons: "{bksp} {backspace}",
                  },
                  {
                    class: "hg-space",
                    buttons: "{space}",
                  },
                ]}
                keyboardRef={(r) => (keyboardRef.current = r)}
                inputName={companyInputName}
                onChangeAll={onChangeCompany}
                onKeyPress={handleKeyboardInputs}
                layoutName={layout}
                theme={"hg-theme-default signUp"}
                display={{
                  "{abc}": "ABC",
                  "{smileys}": "\uD83D\uDE03",
                  "{numbers}": "123",
                  "{number}": "123",
                  "{shift}": "⇧",
                  "{tab}": "tab",
                  "{lock}": "lock",
                  "{enter}": "enter",
                  "{space}": "Space",
                  "{caps}": "ABC",
                  "{small}": "abc",
                }}
                layout={{
                  shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {bksp}", "{number} {space}"],
                  numbers: ["1 2 3", "4 5 6", "7 8 9", "{caps} 0 {bksp}"],
                  number: ["1 2 3", "4 5 6", "7 8 9", "{small} 0 {bksp}"],
                  default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {bksp}", "{numbers} {space}"],
                  num: ["1 2 3", "4 5 6", "7 8 9", " 0 {bksp}"],
                }}
              />
            )}
          </Col>
        </Row>
      </Modal>
      <Modal
        open={laywayModal}
        title={"Layaway Table"}
        closable={true}
        footer={
          <div style={{ display: "flex" }}>
            <Button
              type="primary"
              onClick={() => {
                if (layawayCheck.length > 0) {
                  useRestaurantStore.getState().setLocatedList(tempLocatedList);
                  localStorage.setItem(
                    "layaway",
                    JSON.stringify({
                      table: fbOrderLayawayData[0].fbTableId,
                      value: "true",
                    })
                  );
                  // history.push("/pos");
                  setKeyValue("2");
                }
              }}
              style={{ marginRight: "1vw" }}
            >
              Pay
            </Button>
            <Button
              onClick={() => {
                setLayawayCheck([]);
                setLaywayModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        }
        onCancel={() => {
          setLayawayCheck([]);
          setLaywayModal(false);
        }}
        styles={{ body: { padding: "15px" } }}
        width="35%"
      >
        <Row
          gutter={[16, 16]}
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            padding: "0 3vw",
          }}
        >
          {fbOrderLayawayData.map((node, index) => (
            <div key={`Order${index + 1}`}>
              <Checkbox onChange={(e) => handleCheckboxChange(e, node)}>
                <span style={{ width: "26vw" }}>{`Order - ${index + 1}`}</span> <span style={{ marginLeft: "12vw" }}>{`Price - ${node.total}`}</span>
              </Checkbox>
              <ul>
                {node.lines.map((childNode, ind) => (
                  <li key={ind}>{JSON.parse(childNode.meta[0].value).name}</li>
                ))}
              </ul>
            </div>
          ))}
        </Row>
      </Modal>

      <Drawer
        open={displayReserveTablesPopup}
        placement="right"
        closable={false}
        width="80%"
        className="custom-drawer"
        styles={{ mask: { backgroundColor: "rgba(0,0,0,0.3)" } }}
        styles={{ body: {
          background: "#fff",
        } }}
      >
        {/* 🔥 TOP CONTACT SEARCH INPUT FOR RESERVE TABLE */}
        <Form key={"reserveTable"} form={reserveTableForm} name="reserveTable" onFinish={handleReserveTableDetails}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              height: "2vh",
              fontSize: "1vw",
              marginTop: "1vh",
              paddingBottom: "5vh",
            }}
          >
            <p
              style={{
                fontSize: "2em",
                fontWeight: "500",
                color: "#0F0718",
                flex: 1,
                marginTop: "5vh",
              }}
            >
              Reserve Table
            </p>
            <img
              src={closeX}
              onClick={handleClick}
              style={{
                marginLeft: "auto",
                paddingBottom: "4vh",
                paddingTop: "2vh",
                cursor: "pointer",
                width: "1.5vw",
              }}
            />
          </div>
          <Row>
            <Col span={24} style={{ padding: "0 1vw", marginTop: "1.5vh" }}>
              <Form.Item
                name="mobile"
                rules={[
                  { required: true, message: "Please enter contact number" },
                  { len: 10, message: "Contact number must be 10 digits" },
                ]}
              >
                <Input
                  placeholder="Contact Number"
                  className="restaurantInput"
                  maxLength={10}
                  type="number"
                  onFocus={() => {
                    setInputName("reserveSearchTop");
                    setLayout("number");
                  }}
                  onChange={handleReserveCustomerSearchTop}
                  onKeyPress={(e) => {
                    if (["e", "E", "+", "-", ".", ","].includes(e.key)) e.preventDefault();
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[16, 16]}>
            <Col span={12} style={{ padding: "4vh 2vw" }}>
              {/* NO OF PERSONS (TOP BUTTONS) */}
              <div style={{ marginBottom: "2vh", marginTop: "3vh" }}>
                <p style={{ color: "#0F0718", fontSize: "1em", fontWeight: 500 }}>
                  <span style={{ color: "red", marginRight: 5 }}>*</span>
                  How many guests?
                </p>

                <div className="number-buttons-container" style={{ marginTop: "1vh" }}>
                  {numbers.map((number, index) => (
                    <div
                      key={index}
                      className="number-button"
                      style={{
                        backgroundColor: noOfPersons === number ? "#2F3856" : "#fff",
                        color: noOfPersons === number ? "#fff" : "#0f0718",
                        borderRadius: "8px",
                        padding: "10px 0",
                        fontSize: "1em",
                      }}
                      onClick={() => handleNumberClick(number)}
                    >
                      {number}
                    </div>
                  ))}
                </div>
                <Form.Item name="noOfPersons" rules={[{ required: true, message: "Please select number of guests" }]} style={{ marginBottom: 0 }}>
                  <Input style={{ display: "none" }} />
                </Form.Item>
              </div>

              {/* FORM FIELDS IN 2 COLUMN GRID */}
              <Row gutter={[32, 0]}>
                {/* Name */}
                <Col span={12}>
                  <label style={data.restaurantPos.tableManagement.reserveTableModal.tableDetailsField}>Full Name</label>
                  <Form.Item name="name" rules={[{ required: true, message: "Please enter full name" }]}>
                    <Input
                      placeholder="John Doe"
                      onFocus={() => {
                        setInputName("name");
                        setLayout("default");
                      }}
                    />
                  </Form.Item>

                  <Form.Item name="time" rules={[{ required: true, message: "Please select date & time" }]}>
                    <DatePicker showTime={{ format: "HH:mm" }} format="YYYY-MM-DD HH:mm" placeholder="dd-mm-yyyy --:--" className="timePicker" />
                  </Form.Item>
                </Col>

                {/* Section */}
                <Col span={12}>
                  <label style={data.restaurantPos.tableManagement.reserveTableModal.tableDetailsField}>Section</label>
                  <Form.Item name="section" rules={[{ required: true, message: "Please select section" }]}>
                    <Select placeholder="All Sections" showSearch disabled={radioValue.value !== "all"}>
                      {selectData.map((item) => (
                        <Option value={item.value}>{item.name}</Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* Table */}
                <Col span={24}>
                  <label style={data.restaurantPos.tableManagement.reserveTableModal.tableDetailsField}>Select Table (optional)</label>

                  <Form.Item name="tableNum">
                    <Select placeholder="Choose a table" showSearch>
                      {tableList.map((tableObj) => (
                        <Option key={`${tableObj.cwrFbTableId}-${tableObj.cwrFbsectionId}`} value={`${tableObj.cwrFbTableId}-${tableObj.cwrFbsectionId}`}>
                          {tableObj.title}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                {/* SELECT COMPANY (UNCHANGED) */}
                <Col span={24}>
                  <Form.Item name="referredBy">
                    <Row gutter={[16, 16]}>
                      <Col span={11}>
                        <a onClick={openCompanyData}>Select Company</a>
                      </Col>
                      <Col span={2} />
                      <Col span={11} style={{ textAlign: "center" }}>
                        <span>{companyName}</span>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
            <Col span={12} style={{ paddingTop: "9vh" }}>
              {keyboardVisible && (
                <Keyboard
                  buttonTheme={[
                    {
                      class: "hg-bksp",
                      buttons: "{bksp} {backspace}",
                    },
                    {
                      class: "hg-space",
                      buttons: "{space}",
                    },
                  ]}
                  keyboardRef={(r) => (keyboardRef.current = r)}
                  inputName={inputName}
                  onChangeAll={(inputs) => {
                    setInputFields({ ...inputs });
                    reserveTableForm.setFieldsValue(inputs);
                  }}
                  onKeyPress={handleKeyboardInputs1}
                  layoutName={layout}
                  theme={"hg-theme-default signUp"}
                  display={{
                    "{abc}": "ABC",
                    "{smileys}": "\uD83D\uDE03",
                    "{numbers}": "123",
                    "{number}": "123",
                    "{shift}": "⇧",
                    "{tab}": "tab",
                    "{lock}": "lock",
                    "{enter}": "enter",
                    "{space}": "Space",
                    "{caps}": "ABC",
                    "{small}": "abc",
                  }}
                  layout={{
                    shift: ["q w e r t y u i o p", "a s d f g h j k l", "{shift} z x c v b n m {bksp}", "{number} {space}"],
                    numbers: ["1 2 3", "4 5 6", "7 8 9", "{caps} 0 {bksp}"],
                    number: ["1 2 3", "4 5 6", "7 8 9", "{small} 0 {bksp}"],
                    default: ["Q W E R T Y U I O P", "A S D F G H J K L", "{shift} Z X C V B N M {bksp}", "{numbers} {space}"],
                    num: ["1 2 3", "4 5 6", "7 8 9", " 0 {bksp}"],
                  }}
                />
              )}
              <Row style={data.restaurantPos.tableManagement.reserveTableModal.reserveCancelBtns}>
                <Button
                  size="medium"
                  className="customerDetailsSubmitBtnBtn modal-btn"
                  style={data.restaurantPos.tableManagement.reserveTableModal.reserveTablesSubmitBtn}
                  htmlType="submit"
                  disabled={reserveSubmitting}
                  loading={reserveSubmitting}
                >
                  Reserve
                </Button>
                <Button
                  size="medium"
                  className="customerDetailsCancelBtn modal-btn"
                  style={data.restaurantPos.tableManagement.reserveTableModal.reserveTablesCancelBtn}
                  onClick={() => {
                    setNumberOfPersons("");
                    setInputFields("");
                    setKeyboardVisible(false);
                    reserveTableForm.resetFields();
                    setTimeout(() => {
                      setKeyboardVisible(true);
                      setDisplayReserveTablesPopup(false);
                    }, 0);
                  }}
                >
                  Cancel
                </Button>
              </Row>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </Spin>
  );
};
export default TableManagement;
